import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { useMemo } from 'react';
import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { AgaveCostCode, AgaveSubJob, AgaveProject } from 'API';

interface AgaveCostCodesDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedCostCode?: AgaveCostCode | null;
  selectedSubJob?: AgaveSubJob | null;
  selectedProject?: AgaveProject | null;
  onValueChange: (option: AgaveCostCode | null) => void;
  placeholder?: string | null;
  enabled?: boolean;
  /** Load options only when dropdown opens (use in table rows to avoid stale shared state). */
  fetchOnlyOnOpen?: boolean;
}

const AgaveCostCodesDropdown = ({
  disabled,
  disableHeader = true,
  selectedCostCode,
  selectedSubJob,
  selectedProject,
  onValueChange,
  placeholder,
  enabled = true,
  fetchOnlyOnOpen,
}: AgaveCostCodesDropdownProps) => {
  const { selectedPaidol } = useAppSelector(selectUserCompanies);

  // Check if description should be included in the label
  const includeDescription = useMemo(
    () => selectedPaidol?.erpCostCodesUseDescriptionSetting?.isEnabled ?? false,
    [selectedPaidol?.erpCostCodesUseDescriptionSetting?.isEnabled]
  );

  // When the setting is enabled, the field is inactive until a project is selected
  const requireProjectFirst = Boolean(
    selectedPaidol?.requireProjectBeforeCostCode?.isEnabled && !selectedProject
  );

  return (
    <CodingEntityDropdown<AgaveCostCode>
      entityType="costCodes"
      selectedItem={selectedCostCode}
      onValueChange={onValueChange}
      disabled={disabled || requireProjectFirst}
      disableHeader={disableHeader}
      placeholder={placeholder || undefined}
      identifierField="code"
      projectId={selectedProject?.id}
      subJobId={selectedSubJob?.id}
      enabled={enabled}
      includeDescription={includeDescription}
      dataDropdownType="agave-cost-codes"
      fetchOnlyOnOpen={fetchOnlyOnOpen}
    />
  );
};

export default AgaveCostCodesDropdown;
